import { CircularProgress } from "@material-ui/core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { internalSignInPortAuth } from "../../redux/actions/authActions";

const InternalCallback = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const history = useHistory();

  const code = queryParams.get("code");
  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("InternalCallback");
    const a = async () => {
      try {
        dispatch(internalSignInPortAuth(code));
        // Users get redirected here when the logout from taxis, so when
        // user gets logged out, a code doesn't exist. This means
        // that we should send them to login page again.
        // Otherwise we should send them to dashboard.
        if (!code) {
          history.push("/auth/i-sign-in");
        } else {
          history.push("/");
        }
      } catch (error) {
        console.log(error);
      }
    };
    a();
  }, []);

  return <CircularProgress />;
};

export default InternalCallback;
